import React from 'react'
import { SkeletonText } from '../../atoms/SkeletonText/SkeletonText'

type DetailsItem = {
    label: string
    value: React.ReactNode
    loading?: boolean
}

type DetailsProps = {
    items: DetailsItem[]
}

export const Details: React.FC<DetailsProps> = (props) => {
    const { items } = props

    return (
        <dl
            data-testid="details"
            className="grid grid-cols-[max-content_1fr] gap-4"
        >
            {items.map((item, index) => (
                <div
                    key={index}
                    className="col-span-2 grid grid-cols-[subgrid] border-b border-neutral-200 py-0.5 pb-4 last:border-b-0"
                >
                    <dt className="text-label-small text-subtle after:content-[':']">
                        {item.label}
                    </dt>
                    <dd className="text-body-medium flex text-regular">
                        {item.value ? (
                            item.value
                        ) : item.loading ? (
                            <SkeletonText />
                        ) : (
                            '-'
                        )}
                    </dd>
                </div>
            ))}
        </dl>
    )
}
